import AbstractProvider from '../services/App/AbstractProvider';
import {IControllersRepository} from '../@interfaces/services/ControllersRepository/IControllersRepository';
import controllers from '../../controllers/.controllers';

export class ControllersProvider extends AbstractProvider {
	holdBootUntilNotCompleted = false;

	async boot() {
		const repo = this.getStoredService<IControllersRepository>('controllers');
		for (const [name, constructor] of Object.entries(controllers)) {
			repo.registerController(name, constructor);
		}
	}
}
